import script from "./TrainingList.vue?vue&type=script&lang=ts&setup=true&name=TrainingList"
export * from "./TrainingList.vue?vue&type=script&lang=ts&setup=true&name=TrainingList"

import "./TrainingList.vue?vue&type=style&index=0&id=c9d1283c&scoped=true&lang=stylus"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9d1283c"]])

export default __exports__